// Admin contract (generate_domainviews.mjs scrapes the imports below): one default-import
// per admin-visible block, pointing at a View.svelte whose directory also holds a
// Config.svelte. Keys of the default export MUST equal the import identifiers.
// Do not quote the import pattern in comments — the scraper is a plain regex.
import ContentItem from '@reperio-news/core.components/blocks/ContentItem/View.svelte';
import ContentList from '@reperio-news/core.components/blocks/ContentList/View.svelte';
import Title from '@reperio-news/core.components/blocks/Title/View.svelte';
import Image from '@reperio-news/core.components/blocks/Image/View.svelte';
import RawHTML from '@reperio-news/core.components/blocks/RawHTML/View.svelte';
import EditorContent from '@reperio-news/core.components/blocks/EditorContent/View.svelte';
import AdPosition from '@reperio-news/core.components/blocks/AdPosition/View.svelte';
import TopMenu from './TopMenu/View.svelte';
import Footer from './Footer/View.svelte';
import Dynamic from './Dynamic/View.svelte';
import FinanceStrip from './FinanceStrip/View.svelte';
import MarketStrip from './MarketStrip/View.svelte';

// blocks available in the admin page builder for this domain
export default {
	Dynamic,
	FinanceStrip,
	MarketStrip,
	ContentItem,
	ContentList,
	Title,
	Image,
	RawHTML,
	EditorContent,
	AdPosition,
	TopMenu,
	Footer,
};

import * as ContentItemViews from './ContentItem';
import * as ContentListViews from './ContentList';
import * as TitleViews from './Title';
import * as BlockContainerViews from './BlockContainer/Default.svelte';
import * as AdPositionViews from './AdPosition';

// per-domain layout views of the core blocks (DomainView: [category][type][layout] || .default)
export const DOMAIN_VIEWS = {
	ContentItem: { ...ContentItemViews },
	ContentList: { ...ContentListViews },
	Title: { ...TitleViews },
	BlockContainer: { ...BlockContainerViews },
	AdPosition: { ...AdPositionViews },
};
